import React from 'react'
import { Outlet } from 'react-router-dom';
import SessionTimeOut from '../components/SessionTimeout';

const Content: React.FunctionComponent = () => {
    return (
        <React.Fragment>
            <Outlet />
            <SessionTimeOut />
        </React.Fragment>
    )
}
export default Content